import { useQueries } from '@tanstack/react-query';
import { setupApi } from '@/api/setup';

const FIVE_MIN = 5 * 60 * 1000;

/**
 * Bundled lookups used across student forms. Each query is keyed under
 * the same keyspace as the setup module so cache is shared.
 */
export function useStudentLookups() {
  const queries = useQueries({
    queries: [
      { queryKey: ['setup', 'lookups', 'genders', 'active'], queryFn: () => setupApi.listLookup('genders', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'religions', 'active'], queryFn: () => setupApi.listLookup('religions', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'nationalities', 'active'], queryFn: () => setupApi.listLookup('nationalities', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'blood-groups', 'active'], queryFn: () => setupApi.listLookup('blood-groups', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'relationship-types', 'active'], queryFn: () => setupApi.listLookup('relationship-types', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'lookups', 'leaving-reasons', 'active'], queryFn: () => setupApi.listLookup('leaving-reasons', true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'cities', 'active'], queryFn: () => setupApi.listCities(true), staleTime: FIVE_MIN },
      { queryKey: ['setup', 'academic-years'], queryFn: setupApi.listAcademicYears, staleTime: FIVE_MIN },
    ],
  });
  const [genders, religions, nationalities, bloodGroups, relations, leavingReasons, cities, years] = queries;
  return {
    genders: genders.data ?? [],
    religions: religions.data ?? [],
    nationalities: nationalities.data ?? [],
    bloodGroups: bloodGroups.data ?? [],
    relations: relations.data ?? [],
    leavingReasons: leavingReasons.data ?? [],
    cities: cities.data ?? [],
    years: years.data ?? [],
    isLoading: queries.some((q) => q.isLoading),
  };
}

export const classSectionsKey = (academicYearId: number) =>
  ['setup', 'class-sections', academicYearId] as const;
